export const whatsnew = {
  whatsnew: {
    back: 'BACK',
    dismiss: 'DISMISS',
    done: 'DONE',
    next: 'NEXT',
    header: 'What’s New!',
    listHeader: 'in this release',
    learnMore: 'Learn More',
    step: '{{current}} of {{total}}',
  },
};
